export default __webpack_public_path__ + "static/media/DTEX-UC2-Seq6c-PDF3.114acf65.png";